import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader_2";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_2";
import BlockPrincipal from "../components/block/Block_5";
import BlockSecondary from "../components/block/Block_3";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[39]}`}
        />
        <BlockPrincipal
            title={'a little about us'}
            text={rpdata?.dbAbout?.[0]?.text}
            image={rpdata?.stock?.[2]}
            listsAbout
          />
        <ValuesOne image={rpdata?.gallery?.[45]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.[50]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
